import { render, staticRenderFns } from "./OrderStatistic.vue?vue&type=template&id=f024c0d8&scoped=true&"
import script from "./OrderStatistic.vue?vue&type=script&lang=js&"
export * from "./OrderStatistic.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatistic.vue?vue&type=style&index=0&id=f024c0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vbimex/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f024c0d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vbimex/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDataTable,VFlex,VLayout})
